import React from "react";
import Collapsible from "react-collapsible";
import { toggleInfoPanel } from "../actions/uiPreferences";
import { connect } from "react-redux";

export default function makeCollapsible(WrappedComponent, props) {
  const { title, name, innerClass, ...rest } = props;

  class CollapsibleComponent extends React.Component {
    constructor(props) {
      super(props);
      this.toggleOpen = this.toggleOpen.bind(this);
    }

    toggleOpen() {
      this.props.dispatch(toggleInfoPanel(name));
    }

    render() {
      const { openState } = this.props;
      const headerTitle = <h2>{title}</h2>;

      let combinedProps = Object.assign({}, this.props, rest);
      return (
        <div>
          <Collapsible
            trigger={headerTitle}
            open={openState}
            triggerClassName="Collapsible__trigger container-rounded text-uppercase u-font-foundation-roman u-textSize-20 pY-15"
            triggerOpenedClassName="Collapsible__trigger is-open  container-top-rounded text-uppercase u-font-foundation-roman u-textSize-20 pY-15"
            contentOuterClassName="info-box-content u-font-foundation-roman u-textSize-18"
            contentInnerClassName={innerClass}
            handleTriggerClick={this.toggleOpen}
          >
            <WrappedComponent openState={openState} {...rest} />
          </Collapsible>
        </div>
      );
    }
  }

  const mapStateToProps = state => {
    return {
      openState: state.uiPreferences.infoPanels[name]
    };
  };

  return connect(mapStateToProps)(CollapsibleComponent);
}
